import { Injectable } from '@angular/core';
import { Action, State, StateContext } from '@ngxs/store';
import { EMPTY, catchError, tap } from 'rxjs';
import { CustomerService } from 'src/app/generated/backend/services';
import { mapCustomerDto } from 'src/app/utils/customer.utils';
import {
  LoadAllClientsAction,
  LoadLastClientsAction,
  ResetClientsAction,
  SearchAllClientsAction,
  SearchLastClientsAction,
} from './clients.actions';
import { ClientsStateModel } from './clients.state-model';

export const clientsStateDefaults: ClientsStateModel = {
  allClients: [],
  lastClients: [],
  searchAll: '',
  searchLast: '',
};

@State<ClientsStateModel>({
  name: 'clients',
  defaults: clientsStateDefaults,
})
@Injectable()
export class ClientsState {
  constructor(private customerService: CustomerService) {}

  @Action(LoadAllClientsAction)
  loadAllClients(ctx: StateContext<ClientsStateModel>) {
    return this.customerService.apiCustomerAllGet$Json().pipe(
      tap((response) => {
        ctx.patchState({ allClients: response.map(mapCustomerDto) });
      }),
      catchError((error) => {
        console.error(error);
        return EMPTY;
      })
    );
  }

  @Action(LoadLastClientsAction)
  loadLastClients(ctx: StateContext<ClientsStateModel>) {
    return this.customerService.apiCustomerGet$Json().pipe(
      tap((response) => {
        ctx.patchState({ lastClients: response.map(mapCustomerDto) });
      }),
      catchError((error) => {
        console.error(error);
        return EMPTY;
      })
    );
  }

  @Action(SearchAllClientsAction)
  searchAll(
    ctx: StateContext<ClientsStateModel>,
    { search }: SearchAllClientsAction
  ) {
    ctx.patchState({ searchAll: search });
  }

  @Action(SearchLastClientsAction)
  searchLast(
    ctx: StateContext<ClientsStateModel>,
    { search }: SearchAllClientsAction
  ) {
    ctx.patchState({ searchLast: search });
  }

  @Action(ResetClientsAction)
  reset(ctx: StateContext<ClientsStateModel>) {
    ctx.setState(clientsStateDefaults);
  }
}
